import { useState, useEffect, useCallback } from 'react';
import { useToast } from '@chakra-ui/react';
import CustomToast from '../common/CustomToast';

const isValidOAuthMessage = (event) => {
  return (
    event.data &&
    typeof event.data === 'object' &&
    event.data.type &&
    (event.data.type === 'oauth_success' || event.data.type === 'oauth_error')
  );
};

export const useOAuthPopup = ({ onSuccess, onError }) => {
  const [oauthPopup, setOauthPopup] = useState(null);
  const toast = useToast();

  const showErrorToast = useCallback(
    (title) => {
      toast({
        render: (props) => (
          <CustomToast
            status="error"
            title={title}
            description=""
            onClose={props.onClose}
            id={props.id}
          />
        ),
      });
    },
    [toast]
  );

  useEffect(() => {
    const handleOAuthMessage = (event) => {
      if (!isValidOAuthMessage(event)) return;

      const backendUrl =
        process.env.REACT_APP_API_URL_AXIOS ||
        window.env?.REACT_APP_API_URL_AXIOS;

      if (!event.origin.startsWith(backendUrl)) {
        console.error('OAuth message from unexpected origin:', event.origin);
        return;
      }

      if (oauthPopup && !oauthPopup.closed) {
        oauthPopup.close();
      }

      if (event.data.type === 'oauth_success') {
        const { token } = event.data;

        if (token) {
          onSuccess?.(token);
        } else {
          const errorMessage = 'Authentication failed. Missing credentials.';
          showErrorToast(errorMessage);
          onError?.(errorMessage);
        }
        return;
      }

      if (event.data.type === 'oauth_error') {
        const errorMessage =
          event.data.error || 'Authentication failed. Please try again.';
        showErrorToast(errorMessage);
        onError?.(errorMessage);
      }
    };

    window.addEventListener('message', handleOAuthMessage);

    return () => {
      window.removeEventListener('message', handleOAuthMessage);
    };
  }, [oauthPopup, onSuccess, onError, showErrorToast]);

  return {
    oauthPopup,
    setOauthPopup,
    showErrorToast,
  };
};
